import React, { memo } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const Pagination = memo(function Pagination({
  currentPage,
  totalPages,
  onPageChange,
  itemsPerPage,
  onItemsPerPageChange: _onItemsPerPageChange,
  darkMode = false,
  className = "",
}) {
  const btnNav = darkMode
    ? "border border-gray-600 bg-[#2a2a2a] text-sm font-medium text-gray-200 hover:bg-[#333] disabled:opacity-50"
    : "border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50";

  const btnPageInactive = darkMode
    ? "min-w-[32px] border border-gray-600 bg-[#2a2a2a] px-2 py-1.5 text-sm font-medium text-gray-200 hover:bg-[#333]"
    : "min-w-[32px] border border-gray-300 bg-white px-2 py-1.5 text-sm font-medium text-gray-700 hover:bg-gray-50";

  const btnPageActive =
    "min-w-[32px] rounded bg-redhalo-red px-2 py-1.5 text-sm font-medium text-white shadow-sm";

  return (
    <div
      className={`${darkMode ? "rh-table-footer-bar-dark" : "rh-table-footer-bar"} ${className}`}
    >
      <div className="min-w-0 flex-1 text-sm text-gray-600 dark:text-gray-400" />

      <div className="flex flex-wrap items-center justify-end gap-1">
        <button
          type="button"
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className={`inline-flex items-center rounded px-3 py-1.5 ${btnNav}`}
          aria-label="Previous page"
        >
          <ChevronLeft size={18} />
        </button>

        <div className="flex items-center gap-1">
          {itemsPerPage === "all" ? (
            <button
              type="button"
              key={1}
              onClick={() => onPageChange(1)}
              className={currentPage === 1 ? btnPageActive : btnPageInactive}
            >
              1
            </button>
          ) : (
            Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
              let pageNum;
              if (totalPages <= 5) {
                pageNum = i + 1;
              } else if (currentPage <= 3) {
                pageNum = i + 1;
              } else if (currentPage >= totalPages - 2) {
                pageNum = totalPages - 4 + i;
              } else {
                pageNum = currentPage - 2 + i;
              }

              return (
                <button
                  type="button"
                  key={pageNum}
                  onClick={() => onPageChange(pageNum)}
                  className={
                    currentPage === pageNum ? btnPageActive : btnPageInactive
                  }
                >
                  {pageNum}
                </button>
              );
            })
          )}
        </div>

        <button
          type="button"
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className={`inline-flex items-center rounded px-3 py-1.5 ${btnNav}`}
          aria-label="Next page"
        >
          <ChevronRight size={18} />
        </button>
      </div>
    </div>
  );
});

export default Pagination;
